import { DIM2CLASS } from '../../core/icon-class';
import { Filter } from '../../common/filter';
import { boolDialogCtrl } from '../../admin/modals';
import { AlertModalController } from './alert-modal.component';

require('./filter-editor-modal.component.scss');

export const FilterEditorModalController = function (
  $scope,
  $modal,
  $modalInstance,
  FilterResource,
  Aggregates,
  filter,
  CurrentFilterService,
  model,
  asNew,
  globalAlert,
  ErrorHandlerService,
  StatusCheckerService,
) {
  $scope.model = model;
  $scope.CurrentFilterService = CurrentFilterService;
  $scope.visibleDimensions = model.dimensions;
  $scope.DIM2CLASS = DIM2CLASS;
  $scope.cube = model.cubes[0];
  $scope.filterBar = new Filter('DialogBar');
  $scope.filter = angular.copy(filter);
  let as_text = filter.as_text();
  $scope.filter_as_text = {'data': as_text};
  $scope.filter_as_text_orig = {'data': as_text};
  $scope.filterBar.skipStat = true;
  $scope.filterBar.limit = 100;
  $scope.serverPolicies = false;
  $scope.showDeleteButton = true;
  $scope.StatusChecker = StatusCheckerService;

  $scope.updateAsText = function () {
    $scope.filter_as_text = {'data': $scope.filter.as_text()};
  };
  $scope.updateFromText = function () {
    $scope.filter.from_text($scope.filter_as_text.data);
  };
  $scope.openNodes = {};
  $scope.locLabel = Filter.locLabel;
  $scope.isNodeOpen = function (type, obj) {
    return $scope.openNodes[type] == obj;
  };
  $scope.closeNode = function (type, obj) {
    $scope.openNodes[type] = false;
  };
  $scope.switchNode = function (type, obj, $event) {
    if ($scope.isNodeOpen(type, obj)) $scope.closeNode(
      type,
      obj,
    ); else $scope.openNode(type, obj);
    if ($event) $event.stopPropagation();
  };
  $scope.openNode = function (type, obj) {
    $scope.closeNode(type, obj);
    $scope.openNodes[type] = obj;
  };
  $scope.cells = function () {
    return $scope.aggregate ? $scope.aggregate.cells : [];
  };
  $scope.loadAggregate = function (callback, resetCache) {
    if ($scope.aggregate) {
      $scope.aggregate.blocked = true;
    }
    if (resetCache) $scope.filterBar.page = 0;
    //       let canceler = Cancelers.get('Bar');
    let canceler = null;
    $scope.filterBar.copyFrom($scope.filter, true);
    delete $scope.filterBar.timeFrom;
    delete $scope.filterBar.timeTo;

    if ($scope.filter.content_type === 'backupfilter') {
      $scope.serverPolicies = true;
    }

    if (!$scope.filter.id || $scope.serverPolicies) {
      $scope.showDeleteButton = false;
    }

    if ($scope.aggregate && $scope.filterBar.page === 0) {
      $scope.aggregate = null;
    }
    Aggregates.load(
      $scope.cube.name,
      $scope.filterBar,
      resetCache,
      canceler,
    )
      .then((aggregate) => {
        if (aggregate) {
          if (!$scope.aggregate || !$scope.filterBar.page) {
            $scope.aggregate = aggregate;
            $scope.aggregate.isComplete = false;
          } else {
            $scope.aggregate.isComplete = aggregate.cells.length == 0;
            aggregate.cells.forEach(function (cell) {
              $scope.aggregate.cells.push(cell);
            }, this);
          }
        }
        if ($scope.aggregate) {
          $scope.aggregate.blocked = false;
        }
        $scope.$broadcast('aggregateLoaded');
      })
      .catch(error => {
        ErrorHandlerService.handle(error);
      });
  };
  $scope.aggregate_more = function () {
    if (!$scope.filterBar) return;
    let blocked = $scope.aggregate ? $scope.aggregate.blocked : true;
    $scope.filterBar.page = blocked ? $scope.filterBar.page : $scope.filterBar.page + 1;
    if (!blocked) $scope.loadAggregate(function (error) {
      if (error) globalAlert(error.message);
    }, false);
  };
  $scope.searchAggregate = function (event) {
    if (event && event.keyCode != 13) return false;
    let keyword = angular.element('#aggregate-search-modal').val();
    $scope.filterBar.lookup = keyword;
    $scope.loadAggregate(function (error) {
      if (error) globalAlert(error.message);
    }, true);
  };
  $scope.loadAggregate(null, true);
  $scope.hasData = function () {
    return ($scope.aggregate && $scope.aggregate.cells && $scope.aggregate.cells.length > 0);
  };

  $scope.select = function (dim) {
    if (dim.dimension) {
      $scope.openNode('hierarhy', dim.toString());
      $scope.openNode('dimension', dim.dimension.toString());
    } else {
      $scope.openNode('dimension', dim.toString());
    }
    $scope.filterBar.setDrilldown(dim.toString());
    $scope.filterBar.setKeyword('');
    $scope.filterBar.page = 0;
    $scope.filterBar.lookup = null;
    $scope.loadAggregate();
  };
  $scope.$on('reload', function () {
    $scope.loadAggregate(null, true);
  });
  $scope.hasCellFilter = function (drill, cell) {
    let filter = $scope.model.getCellFilter(drill, cell);
    return $scope.filter.hasFilter(filter);
  };
  $scope.focusName = function () {
    if (!$scope.filter.saved) {
      $scope.filter.name = '';
    }
  };

  $scope.setCellFilter = (drill, cell) => {
    let filter = $scope.model.getCellFilter(drill, cell);
    $scope.filter.toggleFilter(filter);
  };

  $scope.ok = function () {
    let errorStatus = '';
    let errorText = '';
    if (filter.content_type === 'backupfilter') {
      if (!angular.isNumber($scope.filter.hdd_alarm_percentage) || !angular.isNumber(
          $scope.filter.hdd_hard_percentage)) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Введите целое число');
      }
      if ($scope.filter.hdd_backup_path == '') {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Задайте путь резервного копирования');
      }
      if ($scope.filter.hdd_alarm_percentage < 0 || $scope.filter.hdd_hard_percentage < 0) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Значения должны быть больше нуля');
      }
    }
    if ($scope.filter.name == '') {
      errorStatus = gettext('Ошибка');
      errorText = gettext('Задайте имя фильтра');
    }
    if (errorText !== '' && errorStatus !== '') {
      $modal.open({
        template  : require('./alert-modal.component.html'),
        controller: AlertModalController,
        resolve   : {
          errorStatus: () => errorStatus,
          errorText  : () => errorText,
        },
      });
      return;
    }
    if (as_text != $scope.filter_as_text.data) {
      $scope.filter.from_text($scope.filter_as_text.data);
    }
    if (asNew) {
      $scope.filter.id = 0;
    }

    FilterResource.save($scope.filter, function (status, data, error) {
      if (error) {
        globalAlert(error.message);
      } else {
        if (status === 200) {
          $modalInstance.close(data);
        }
        if (status === 422) {
          $modal.open({
            template  : require('./alert-modal.component.html'),
            controller: AlertModalController,
            resolve   : {
              errorStatus: () => gettext('Ошибка'),
              errorText  : () => gettext('Заполните необходимые поля.'),
            },
          });
          $scope.errors = data;
        }
      }
    });
  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };

  $scope.delete = function () {
    console.log('Delete filter!');
    $modal.open({
      templateUrl: 'boolDialog.html',
      controller : boolDialogCtrl,
//         message:
    })
      .result
      .then(result => {
        // console.log(result);
        if (result) {
          return FilterResource.delete($scope.filter)
            .then(() => {
              $modalInstance.close(null);
            })
            .catch((error) => {
              globalAlert(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

};




// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor-modal.component.js